import React, { useCallback, useEffect, useRef, useState } from 'react';
import './StickyFooter.scss';

export default function StickyFooter({
  containerRef,
  refresh = 0,
  bottomSpacerHeight = 0,
  children,
}) {
  const [isFixed, setIsFixed] = useState(true);
  const barRef = useRef(null);

  const calc = useCallback(() => {
    if (!containerRef?.current || !barRef.current) return;
    const btn = barRef.current.getBoundingClientRect();
    const cont = containerRef.current.getBoundingClientRect();
    if (cont.bottom + bottomSpacerHeight < btn.top) setIsFixed(false);
    if (btn.bottom > window.innerHeight) setIsFixed(true);
  }, [containerRef, bottomSpacerHeight]);

  useEffect(() => {
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
    const loop = async () => {
      for (let i = 0; i < 10; i++) { calc(); await sleep(100); }
    };
    setTimeout(loop, 0);
  }, [calc, refresh]);

  useEffect(() => {
    const onScroll = () => calc();
    const onResize = () => calc();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    window.addEventListener('focusin', onResize);
    window.addEventListener('focusout', onResize);
    calc();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
      window.removeEventListener('focusin', onResize);
      window.removeEventListener('focusout', onResize);
    };
  }, [calc]);

  return (
    <div
      ref={barRef}
      className={`stickyFooter ${isFixed ? 'stickyFooter--fixed' : 'stickyFooter--flow'}`}
    >
      {children}
    </div>
  );
}


